import { Routes, Route } from 'react-router-dom';
import React from 'react';
import { VaultDashboard } from './VaultDashboard';
import { VaultList } from './vaults/VaultList';
import { VaultDetail } from './vaults/VaultDetail';
import { AccessRequests } from './access/AccessRequests';
import { RotationCenter } from './rotation/RotationCenter';
import { VaultAudit } from './audit/VaultAudit';
import { RequirePermissionRoute } from '../../components/RequirePermissionRoute';

/** Wrap an element in a route-level permission guard (module 'Vault'). */
const g = (el: React.ReactNode, action = 'View') => (
  <RequirePermissionRoute moduleName="Vault" resource="Vault" action={action}>
    {el}
  </RequirePermissionRoute>
);

export function VaultHub() {
  return (
    <div className="flex-1 flex flex-col min-h-0 w-full h-full">
      <Routes>
        <Route index element={<VaultDashboard />} />
        <Route path="/vaults" element={g(<VaultList />)} />
        <Route path="/vaults/:vaultId" element={g(<VaultDetail />)} />
        <Route path="/requests" element={g(<AccessRequests />)} />
        <Route path="/rotation" element={g(<RotationCenter />)} />
        <Route path="/audit" element={g(<VaultAudit />)} />
      </Routes>
    </div>
  );
}
